import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch("https://api.showmeyourjunk.biz/api/vendor/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        alert(data.error || "Login failed. Check email and password.");
        setLoading(false);
        return;
      }

      // Save vendor token + id
      localStorage.setItem("vendor_token", data.vendor_token);
      localStorage.setItem("vendor_id", data.vendor_id);

      // Redirect vendor to dashboard
      navigate("/dashboard");

    } catch (err) {
      console.error("Login error:", err);
      alert("A network or server error occurred.");
    }

    setLoading(false);
  }

  return (
    <div style={{ padding: 40 }}>
      <h1>Vendor Login</h1>

      <form onSubmit={handleSubmit} style={{ maxWidth: 300 }}>
        <label>Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <label>Password</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit" style={{ marginTop: 20 }} disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
}
